import { UserGroup } from "./types";

export const initialUserGroup: UserGroup = {
  id: -1,
  name: "",
  users: [],
  active: true,
  notes: "",
};
